const { nextTick } = require('vue');
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OPERATORS = exports.ProgramsData = exports.Robot = exports.RobotProgram = exports.RobotCode = exports.IO_GROUP = exports.PathTypeName = exports.Ucs = exports.Machine = exports.Entity = exports.PositionRotation = exports.MachineModel = exports.Axis = exports.Project = exports.IO_TYPE_NAME = exports.IO_TYPE = exports.VAL_TYPE_NAME = exports.VAL_TYPE_CHECK = exports.VAL_TYPE = exports.DEVICE_TYPE_NAME = exports.ENTITY_TYPE = exports.MODEL_TYPE = void 0;
const tslib_1 = require("tslib");
const laborer_1 = require("@/store/modules/laborer");
const work_1 = require("@/store/modules/work");
const api_1 = tslib_1.__importDefault(require("@/api"));
const utils_1 = require("@/utils");
const ast_1 = require("@/utils/ast");
const IOCfg_json_1 = tslib_1.__importDefault(require("@/assets/IOCfg.json"));
const project_1 = require("@/service/project");
const user_1 = require("@/service/user");
var MODEL_TYPE;
(function (MODEL_TYPE) {
    MODEL_TYPE["NONE"] = "none";
    MODEL_TYPE["ROBOT"] = "robot";
    MODEL_TYPE["TOOL"] = "tool";
    MODEL_TYPE["DEVICE"] = "device";
    MODEL_TYPE["FIXTURE"] = "fixture";
})(MODEL_TYPE || (exports.MODEL_TYPE = MODEL_TYPE = {}));
var ENTITY_TYPE;
(function (ENTITY_TYPE) {
    ENTITY_TYPE["NONE"] = "None";
    ENTITY_TYPE["ROBOT"] = "Robot";
    ENTITY_TYPE["TOOL"] = "Tool";
    ENTITY_TYPE["DEVICE"] = "Device";
    ENTITY_TYPE["TOOL0"] = "Tool0";
    ENTITY_TYPE["Table"] = "Table";
    ENTITY_TYPE["TCP"] = "Tcp";
    ENTITY_TYPE["UCS"] = "Ucs";
    ENTITY_TYPE["PATH"] = "Path";
})(ENTITY_TYPE || (exports.ENTITY_TYPE = ENTITY_TYPE = {}));
var DEVICE_TYPE_NAME;
(function (DEVICE_TYPE_NAME) {
    DEVICE_TYPE_NAME["None"] = "NONE";
    DEVICE_TYPE_NAME["Robot"] = "\u673A\u5668\u4EBA";
    DEVICE_TYPE_NAME["Tool"] = "\u5939\u5177";
    DEVICE_TYPE_NAME["Device"] = "\u8BBE\u5907";
    DEVICE_TYPE_NAME["Table"] = "\u5DE5\u5177";
    DEVICE_TYPE_NAME["Tool0"] = "\u5DE5\u5177\u5750\u6807\u7CFB";
    DEVICE_TYPE_NAME["Tcp"] = "\u5DE5\u5177Tcp";
    DEVICE_TYPE_NAME["Ucs"] = "\u5750\u6807\u7CFB";
    DEVICE_TYPE_NAME["Path"] = "\u8F68\u8FF9";
    DEVICE_TYPE_NAME["Program"] = "\u7F16\u7A0B";
    DEVICE_TYPE_NAME["RP"] = "\u7528\u6237\u5750\u6807\u7CFB";
})(DEVICE_TYPE_NAME || (exports.DEVICE_TYPE_NAME = DEVICE_TYPE_NAME = {}));
var VAL_TYPE;
(function (VAL_TYPE) {
    VAL_TYPE["DOUBLE"] = "double";
    VAL_TYPE["INT"] = "int";
    VAL_TYPE["STRING"] = "string";
    VAL_TYPE["BOOLEAN"] = "boolean";
    VAL_TYPE["JOINT"] = "joint";
    VAL_TYPE["POSE"] = "pose";
    VAL_TYPE["LABEL"] = "label";
})(VAL_TYPE || (exports.VAL_TYPE = VAL_TYPE = {}));
var VAL_TYPE_CHECK;
(function (VAL_TYPE_CHECK) {
    VAL_TYPE_CHECK["double"] = "Number";
    VAL_TYPE_CHECK["int"] = "Number";
    VAL_TYPE_CHECK["string"] = "String";
    VAL_TYPE_CHECK["boolean"] = "Boolean";
    VAL_TYPE_CHECK["array"] = "Array";
    VAL_TYPE_CHECK["joint"] = "Joint";
    VAL_TYPE_CHECK["pose"] = "Pose";
})(VAL_TYPE_CHECK || (exports.VAL_TYPE_CHECK = VAL_TYPE_CHECK = {}));
var VAL_TYPE_NAME;
(function (VAL_TYPE_NAME) {
    VAL_TYPE_NAME["DOUBLE"] = "\u6570\u5B57";
    VAL_TYPE_NAME["INT"] = "\u6574\u6570";
    VAL_TYPE_NAME["STRING"] = "\u6587\u672C";
    VAL_TYPE_NAME["BOOLEAN"] = "\u771F\u5047";
    VAL_TYPE_NAME["POSE"] = "\u4F4D\u59FF";
    VAL_TYPE_NAME["JOINT"] = "\u5173\u8282";
    VAL_TYPE_NAME["LABEL"] = "\u4E66\u7B7E";
})(VAL_TYPE_NAME || (exports.VAL_TYPE_NAME = VAL_TYPE_NAME = {}));
var IO_TYPE;
(function (IO_TYPE) {
    IO_TYPE["DI"] = "DI";
    IO_TYPE["DO"] = "DO";
    IO_TYPE["AI"] = "AI";
    IO_TYPE["AO"] = "AO";
    IO_TYPE["GI"] = "GI";
    IO_TYPE["GO"] = "GO";
})(IO_TYPE || (exports.IO_TYPE = IO_TYPE = {}));
var IO_TYPE_NAME;
(function (IO_TYPE_NAME) {
    IO_TYPE_NAME["DI"] = "\u6570\u5B57\u4FE1\u53F7\u8F93\u5165";
    IO_TYPE_NAME["DO"] = "\u6570\u5B57\u4FE1\u53F7\u8F93\u51FA";
    IO_TYPE_NAME["AI"] = "\u6A21\u62DF\u4FE1\u53F7\u8F93\u5165";
    IO_TYPE_NAME["AO"] = "\u6A21\u62DF\u4FE1\u53F7\u8F93\u51FA";
    IO_TYPE_NAME["GI"] = "\u5341\u8FDB\u5236\u4FE1\u53F7\u8F93\u5165";
    IO_TYPE_NAME["GO"] = "\u5341\u8FDB\u5236\u4FE1\u53F7\u8F93\u51FA";
})(IO_TYPE_NAME || (exports.IO_TYPE_NAME = IO_TYPE_NAME = {}));
class ProjectState {
    inc(type) {
        var _a;
        this.inc_ids.set(type, (this.inc_ids.get(type) || 0) + 1);
        return ((_a = this.inc_ids.get(type)) === null || _a === void 0 ? void 0 : _a.toString()) || "1";
    }
    constructor(props) {
        this.inc_ids = new Map();
        this.design = {};
        this.program = {};
        if (props) {
            if (props.inc_ids) {
                this.inc_ids.clear();
                Object.keys(props.inc_ids).forEach((key) => {
                    let id = props.inc_ids[key];
                    this.inc_ids.set(key, id);
                });
            }
            this.design = props.design || {};
            this.program = props.program || {};
        }
    }
    toJson() {
        return {
            inc_ids: Object.fromEntries(this.inc_ids),
            design: this.design,
            program: this.program,
        };
    }
}
class Project {
    constructor() {
        this.id = 0;
        this._newEntityId = 0;
        this.open = false;
        this.name = "";
        this.version = 1;
        this.machines = [];
        this.state = new ProjectState();
    }
    get project_id() {
        return this.id;
    }
    set project_id(id) {
        this.id = id;
    }
    get project_name() {
        return this.name;
    }
    set project_name(name) {
        this.name = name;
    }
    get project_version() {
        return this.version;
    }
    set project_version(version) {
        this.version = version;
    }
    static current() {
        let work = (0, work_1.useWork)();
        return work.projects.find((p) => p.open);
    }
    static replace(project) {
        let work = (0, work_1.useWork)();
        work.projects.length = 0;
        work.projects.push(project);
        Project.select(project.id);
        project.machines.forEach((machine) => {
            if (machine.type === ENTITY_TYPE.ROBOT) {
                let robot = machine;
                let fixPath = (path) => {
                    let io = robot.createIO("", IO_TYPE.DI);
                    io.usingType = 'feedBin';
                    io.name = "#" + io.id.replace("$io", "");
                    robot.code.ioList.push(io);
                    path.ioId = io.id;
                };
                robot.paths = robot.paths.map((item) => {
                    let path = item;
                    if (path.ioId) {
                        let pathIo = robot.code.ioList.find((io) => path.ioId === io.id);
                        if (!pathIo) {
                            fixPath(path);
                        }
                        else {
                            pathIo.usingType = 'feedBin';
                        }
                        while (path.points.length < 3) {
                            path.points.push([0, 0, 0, 0, 0, 0]);
                        }
                    }
                    else if (path.io) {
                        if (!robot.code.ioList.find((io) => io.name == path.io)) {
                            fixPath(path);
                        }
                    }
                    delete path.io;
                    return path;
                });
            }
        });
        work.projectSaveState = "";
        work.selectNode(null);
        let laborer = (0, laborer_1.useLaborer)();
        laborer.pointState = null;
        nextTick(() => {
            work.notifyChangeProgram();
            work.notifyChangeProject();
        });
    }
    static select(id) {
        let work = (0, work_1.useWork)();
        let result;
        work.projects.forEach((project) => {
            project.open = project.id == id;
            if (project.open)
                result = project;
        });
        return result;
    }
    static getById(id) {
        let work = (0, work_1.useWork)();
        return work.projects.find((p) => p.id === id);
    }
    getNewId(type, prefix = null) {
        prefix = prefix == null ? "$" + type : prefix;
        return `${prefix}${this.state.inc(type)}`;
    }
    setNewMachineName(machine, name) {
        let index = 0;
        do {
            machine.name = `${name ? name : DEVICE_TYPE_NAME[machine.type]}${++index}`;
        } while (this.machines.find((e) => e.name === machine.name));
    }
    createUcs(origin = null, isAddToMachine = true) {
        let ucs = new Ucs();
        ucs.id = this.getNewId("entity");
        this.setNewMachineName(ucs);
        if (isAddToMachine) {
            this.addMachine(ucs);
        }
        return ucs;
    }
    getUcs(base = true) {
        let result = base
            ? [
                new Ucs({ id: "$base", name: "基坐标系" }, ENTITY_TYPE.UCS),
                new Ucs({ id: "$tool", name: "工具坐标系" }, ENTITY_TYPE.TCP),
            ]
            : [];
        return result
            .concat(this.machines.filter((e) => e.type === ENTITY_TYPE.UCS))
            .filter((e) => e.name);
    }
    createTcp({ origin, status, } = {}, isAddToMachine) {
        let tcp = this.createUcs(origin || null, isAddToMachine);
        tcp.type = ENTITY_TYPE.TCP;
        tcp.status = status || null;
        tcp.setReference("tool");
        this.setNewMachineName(tcp);
        return tcp;
    }
    createRp() {
        let rp = this.createUcs(null, false);
        rp.type = ENTITY_TYPE.TCP;
        rp.setReference('rp');
        this.setNewMachineName(rp, DEVICE_TYPE_NAME.RP);
        return rp;
    }
    createMachine(model, isAddToMachine = true) {
        let machine = Machine.createFromModel(model, this);
        this.setNewMachineName(machine);
        if (isAddToMachine) {
            this.addMachine(machine);
        }
        return machine;
    }
    findMachineById(entityId) {
        return (this.machines.find((device) => device.id === entityId) ||
            this.machines.find((device) => { var _a; return ((_a = device === null || device === void 0 ? void 0 : device.tool) === null || _a === void 0 ? void 0 : _a.id) === entityId; }) ||
            this.machines.find((device) => {
                if (device.type === ENTITY_TYPE.ROBOT) {
                    let robot = device;
                    if (robot.tcps.find((tcp) => tcp.id === entityId)) {
                        return true;
                    }
                    if (robot.paths.find((path) => path.id === entityId)) {
                        return true;
                    }
                }
                return false;
            }));
    }
    findMachineByType(type) {
        return this.machines.filter((e) => e.type === type);
    }
    findTargetById(id) {
        var _a;
        let res = null;
        for (let i = 0; i < this.machines.length && !res; i++) {
            let machine = this.machines[i];
            if (machine.id === id) {
                res = machine;
            }
            else if (machine.type === ENTITY_TYPE.ROBOT) {
                let robot = machine;
                if (((_a = robot.tool) === null || _a === void 0 ? void 0 : _a.id) === id) {
                    res = robot.tool;
                }
                if (!res && robot.tcps.length > 0) {
                    res = robot.tcps.find((tcp) => tcp.id === id);
                }
                if (!res && robot.paths.length > 0) {
                    res = robot.paths.find((path) => path.id === id);
                }
            }
        }
        return res;
    }
    addMachine(machine, parentId) {
        console.info("project.addMachine");
        let father;
        if (!parentId || !(father = this.findMachineById(parentId))) {
            this.machines.push(machine);
        }
        else {
            switch (machine.type) {
                case ENTITY_TYPE.TOOL:
                    father.setTool(machine);
                    break;
                default: {
                    this.machines.push(machine);
                }
            }
        }
        if (machine.type === ENTITY_TYPE.ROBOT) {
            this.selectProgram(machine.id, machine.code.programs[0].id);
        }
        let work = (0, work_1.useWork)();
        work.notifyAddMachine(machine);
    }
    removeMachine(id) {
        let machine = this.machines.find((e) => e.id === id);
        if (machine == null) {
            return;
        }
        let index = this.machines.indexOf(machine);
        if (index === -1) {
            return;
        }
        this.machines.splice(index, 1);
        (0, work_1.useWork)().notifyRemoveMachine(id);
    }
    hideMachine(id, isHidden = true) {
        let machine = this.machines.find((e) => e.id === id);
        if (machine) {
            machine.isHidden = isHidden;
            if (isHidden) {
                (0, work_1.useWork)().notifyHideMachine(id);
            }
            else {
                (0, work_1.useWork)().notifyShowMachine(id);
            }
        }
    }
    selectEntity(entity) {
        let work = (0, work_1.useWork)();
        if (entity) {
            work.notifySelectMachine(entity.id);
        }
        else if (this.machines.length) {
            work.notifySelectMachine(this.machines[0].id);
        }
    }
    selectProgram(robotId, programId) {
        let robot = this.findMachineById(robotId);
        this.state.program = { robot_id: robot.id, program_id: programId };
        let work = (0, work_1.useWork)();
        work.notifyChangeProgram();
    }
    get curProgram() {
        var _a;
        let robot = this.findMachineById(this.state.program.robot_id);
        let program = (_a = robot === null || robot === void 0 ? void 0 : robot.code) === null || _a === void 0 ? void 0 : _a.getProgram(this.state.program.program_id);
        return {
            robot,
            program,
            getVar(varName) {
                return ((program === null || program === void 0 ? void 0 : program.localVars.find((v) => utils_1.Utils.pinyin(v.name) == utils_1.Utils.pinyin(varName))) ||
                    robot.code.globalVars.find((v) => utils_1.Utils.pinyin(v.name) == utils_1.Utils.pinyin(varName)));
            },
            getVars(varName) {
                let vars = (program === null || program === void 0 ? void 0 : program.localVars.filter((v) => utils_1.Utils.pinyin(v.name) == utils_1.Utils.pinyin(varName))) || [];
                let g_vars = robot.code.globalVars.filter((v) => utils_1.Utils.pinyin(v.name) == utils_1.Utils.pinyin(varName)) || [];
                return vars.concat(g_vars);
            },
        };
    }
    saveProject() {
        let json = JSON.stringify(this.toJson());
        return (0, api_1.default)("project.save", {
            data: json,
            id: this.id,
            name: this.name,
            version: this.version,
            status: 1
        });
    }
    saveProjectCache() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let projects = Project.getLocalProjectCache();
            let project = {
                pid: this.id,
                p_name: this.name,
                json_data: this.toJson(),
                timestamp: new Date().getTime(),
            };
            let userInfo = yield (0, user_1.getUserInfo)();
            projects.set(userInfo.username, project);
            localStorage.setItem("projects", JSON.stringify(Object.fromEntries(projects)));
        });
    }
    static clearProjectCache() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let projects = Project.getLocalProjectCache();
            let userInfo = yield (0, user_1.getUserInfo)();
            projects.delete(userInfo.username);
            localStorage.setItem("projects", JSON.stringify(Object.fromEntries(projects)));
        });
    }
    static clearAllCache() {
        localStorage.removeItem("projects");
    }
    static getLocalProjectCache() {
        let projectsStr = localStorage.getItem("projects");
        let projects;
        if (!projectsStr || projectsStr.length === 0) {
            projects = new Map();
            localStorage.setItem("projects", JSON.stringify(Object.fromEntries(projects)));
        }
        else {
            projects = new Map(Object.entries(JSON.parse(projectsStr)));
        }
        return projects;
    }
    static getProjectCache(username) {
        let projects = Project.getLocalProjectCache();
        return projects.get(username) || null;
    }
    static reduceResProjectData(e) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                let restoreData = (_a = e.json_data) === null || _a === void 0 ? void 0 : _a.operationList;
                let project;
                if (!e.json_data) {
                    project = yield Project.formJson(e);
                    return project;
                }
                if (restoreData == null) {
                    project = yield Project.formJson(e.json_data);
                    project.project_name = e.p_name;
                    project.id = e.pid;
                    return project;
                }
                project = new Project();
                project.project_name = e.p_name;
                project.id = e.pid;
                let addEntitys = restoreData.filter((e) => (e || {}).type === "AddEntity");
                let meshs = restoreData.filter((e) => (e || {}).type === "LoadMeshState");
                (addEntitys || []).forEach((e) => {
                    let model = new MachineModel();
                    model.type = e.result.conf.type;
                    let device = project.createMachine(model);
                    let deviceMesh = meshs.find((mesh) => mesh.result.rootMeshID === e.result.conf.specifiedID);
                    device.pr.x = (deviceMesh === null || deviceMesh === void 0 ? void 0 : deviceMesh.result.state.position._x) || 0;
                    device.pr.y = (deviceMesh === null || deviceMesh === void 0 ? void 0 : deviceMesh.result.state.position._y) || 0;
                    device.pr.z = (deviceMesh === null || deviceMesh === void 0 ? void 0 : deviceMesh.result.state.position._z) || 0;
                    project.addMachine(device);
                });
                return project;
            }
            catch (e) {
                console.error(e);
            }
            return new Project();
        });
    }
    static formJson(json) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let project = new Project();
            project.id = json.id || json.pid;
            project.name = json.name || json.project_name;
            project.version = json.version || json.project_version;
            project.state = new ProjectState(json.state);
            Project._curOpening = project;
            project.machines = (json.devices || json.machines || []).map((e) => {
                let device;
                if (e.type === ENTITY_TYPE.ROBOT) {
                    device = Robot.fromJson(e);
                }
                else if (e.type === ENTITY_TYPE.UCS) {
                    device = Ucs.fromJson(e);
                }
                else {
                    device = Machine.fromJson(e);
                }
                return device;
            });
            let devices = (yield (0, project_1.getDevicesInfos)());
            project.machines.forEach((machine) => {
                if (machine.type === ENTITY_TYPE.ROBOT) {
                    let model = devices.find((e) => e.name === machine.modelName);
                    machine.setModel(MachineModel.formJson(model));
                    if (machine.tool) {
                        let toolModel = devices.find((e) => e.name === machine.tool.modelName);
                        if (toolModel)
                            machine.tool.setModel(MachineModel.formJson(toolModel));
                    }
                }
            });
            Project._curOpening = null;
            return project;
        });
    }
    toJson() {
        return {
            state: this.state.toJson(),
            machines: (this.machines || []).map((e) => e.toJson()),
        };
    }
}
exports.Project = Project;
Project._curOpening = null;
class Axis {
    get zAngle() {
        return this.rotateMode == 1 ? -this.val : this.val;
    }
    constructor(data) {
        this.index = 0;
        this.isLocked = false;
        this.val = 0;
        this.rotateMode = 0;
        this.index = data.index;
        this.isLocked = data.isLocked;
        this.val = data.val;
        this.rotateMode = data.rotateMode;
    }
    toJson() {
        return {
            index: this.index,
            isLocked: this.isLocked,
            val: this.val,
            rotateMode: this.rotateMode,
        };
    }
    static fromJson(json) {
        return new Axis(json);
    }
}
exports.Axis = Axis;
class MachineModel {
    constructor() {
        this.type_id = 0;
        this.name = "";
        this.type = MODEL_TYPE.NONE;
        this.file_names = [];
        this.zAxes = [];
        this.TCP = [];
        this.rotateModes = [];
        this.maxLimit = [];
        this.minLimit = [];
        this.zeroAngle = [];
        this.offsetAngle = [];
        this.brand = "";
        this.upload_ids = [];
        this.cover = "";
        this.path = [];
        this.scene = "";
        this.load = "";
        this.arm_span = "";
        this.mounting_way = "";
        this.technology = "";
    }
    get z_axes() {
        return this.zAxes;
    }
    set z_axes(data) {
        this.zAxes = data;
    }
    get zero_angle() {
        return this.zeroAngle;
    }
    set zero_angle(data) {
        this.zeroAngle = data;
    }
    get offset_angle() {
        return this.offsetAngle;
    }
    set offset_angle(data) {
        this.offsetAngle = data;
    }
    static formJson(json) {
        var _a;
        let model = new MachineModel();
        model.type_id = json.id;
        model.name = json.name;
        model.type = json.type;
        model.file_names = json.file_names;
        model.upload_ids = json.upload_ids;
        model.path = json.path;
        model.cover = json.cover;
        model.TCP = json.tcp;
        model.brand = json.brand;
        model.scene = json.scene;
        model.load = json.load;
        model.arm_span = json.arm_span;
        model.mounting_way = json.mounting_way;
        model.technology = json.technology;
        if (model.type == MODEL_TYPE.ROBOT) {
            model.zAxes = json.zAxes || json.z_axes;
            model.maxLimit = json.maxLimit || json.max_limit;
            model.minLimit = json.minLimit || json.min_limit;
            model.zero_angle =
                json.zeroAngle ||
                    json.zero_angle ||
                    (json.minLimit || []).map((e) => 0);
            (json.min_limit || []).map((e) => 0);
            try {
                model.offsetAngle = json.offsetAngle || json.offset_angle || ((_a = json.minLimit) === null || _a === void 0 ? void 0 : _a.map((e) => 0)) || json.min_limit.map((e) => 0);
            }
            catch (e) {
                debugger;
            }
            model.rotateModes = json.rotateModes || json.rotate_modes || [];
        }
        return model;
    }
    toJson() {
        return {
            id: this.type_id,
            name: this.name,
            dev_type: this.type,
            file_names: this.file_names,
            upload_ids: this.upload_ids,
            cover: this.cover,
            z_axes: this.z_axes,
            tcp: this.TCP,
            max_limit: this.maxLimit,
            min_limit: this.minLimit,
            zero_angle: this.zero_angle,
            offset_angle: this.offset_angle,
            brand: this.brand,
            rotate_modes: this.rotateModes,
            scene: this.scene,
            load: this.load,
            arm_span: this.arm_span,
            mounting_way: this.mounting_way,
            technology: this.technology,
        };
    }
}
exports.MachineModel = MachineModel;
class PositionRotation {
    constructor({ x = 0, y = 0, z = 0, rx = 0, ry = 0, rz = 0 } = {}) {
        this.x = 0;
        this.y = 0;
        this.z = 0;
        this.rx = 0;
        this.ry = 0;
        this.rz = 0;
        this.x = x;
        this.y = y;
        this.z = z;
        this.rx = rx;
        this.ry = ry;
        this.rz = rz;
    }
    toJson() {
        return {
            x: this.x,
            y: this.y,
            z: this.z,
            rx: this.rx,
            ry: this.ry,
            rz: this.rz,
        };
    }
    static formJson(json) {
        return new PositionRotation(json);
    }
}
exports.PositionRotation = PositionRotation;
class Entity {
    get x() {
        return this.pr.x;
    }
    set x(val) {
        this.pr.x = val;
    }
    get y() {
        return this.pr.y;
    }
    set y(val) {
        this.pr.y = val;
    }
    get z() {
        return this.pr.z;
    }
    set z(val) {
        this.pr.z = val;
    }
    get rx() {
        return this.pr.rx;
    }
    set rx(val) {
        this.pr.rx = val;
    }
    get ry() {
        return this.pr.ry;
    }
    set ry(val) {
        this.pr.ry = val;
    }
    get rz() {
        return this.pr.rz;
    }
    set rz(val) {
        this.pr.rz = val;
    }
    constructor({ id, name } = {}) {
        this.id = "";
        this.name = "";
        this.type = ENTITY_TYPE.NONE;
        this.isHidden = false;
        this.pr = new PositionRotation();
        this.id = id || "";
        this.name = name || "";
    }
    get typeName() {
        return DEVICE_TYPE_NAME[this.type];
    }
    toJson() {
        return {
            id: this.id,
            name: this.name,
            type: this.type,
            isHidden: this.isHidden,
            pr: this.pr.toJson(),
        };
    }
}
exports.Entity = Entity;
class Machine extends Entity {
    get model() {
        return this._model;
    }
    constructor(args = {}) {
        super(args);
        this._model = new MachineModel();
        this.modelName = "";
    }
    static createFromModel(model, project) {
        let machine;
        if (model.type === MODEL_TYPE.ROBOT) {
            machine = new Robot();
            machine.code.programs.push(machine.createProgram("主程序"));
        }
        else {
            machine = new Machine();
        }
        machine.id = project.getNewId(model.type);
        machine.setModel(model);
        return machine;
    }
    setModel(model) {
        if (this.id == null)
            throw new Error("this.id is required");
        this._model = model;
        if (this.model.type === MODEL_TYPE.TOOL ||
            this.model.type === MODEL_TYPE.FIXTURE) {
            this.type = ENTITY_TYPE.TOOL;
        }
        else if (this.model.type === MODEL_TYPE.DEVICE) {
            this.type = ENTITY_TYPE.DEVICE;
        }
    }
    toJson() {
        let superJson = super.toJson();
        superJson.modelName = this.model.name;
        return superJson;
    }
    getUcs() {
        let res = [];
        if (this.type === ENTITY_TYPE.TOOL) {
            res.push(new Ucs({ id: "tool", name: "工具坐标系" }));
        }
        else if (this.type === ENTITY_TYPE.ROBOT ||
            this.type === ENTITY_TYPE.DEVICE) {
            res.push(new Ucs({ id: "global", name: "大地坐标系" }));
        }
        else if (this.type === ENTITY_TYPE.TCP) {
            res.push(new Ucs({ id: "base", name: "基坐标系" }), new Ucs({ id: "tool", name: "工具坐标系" }));
            res = res.concat(...Project.current().machines.filter((e) => e.id != this.id));
        }
        else if (this.type === ENTITY_TYPE.UCS) {
            res.push(new Ucs({ id: "global", name: "大地坐标系" }));
            res = res.concat(...Project.current().machines.filter((e) => e.id != this.id));
        }
        return res;
    }
    static fromJson(json) {
        if (json == null)
            return null;
        let machine = new Machine();
        machine.id = json.id;
        machine.name = json.name;
        machine.type = json.type;
        machine.pr.x = json.pr.x;
        machine.pr.y = json.pr.y;
        machine.pr.z = json.pr.z;
        machine.pr.rx = json.pr.rx;
        machine.pr.ry = json.pr.ry;
        machine.pr.rz = json.pr.rz;
        machine.modelName = json.modelName;
        machine.isHidden = !!json.isHidden;
        if (machine.modelName === "" && json.model) {
            machine.modelName = json.model.name;
        }
        return machine;
    }
}
exports.Machine = Machine;
class Ucs extends Machine {
    get refPoints() {
        if (this._reference.frame !== 'rp') {
            throw new Error('ucs type error');
        }
        if (!this._refPoints) {
            this._refPoints = {
                R1: { name: "R1", data: [[0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0]] },
                R2: { name: "R2", data: [[0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0]] },
                R3: { name: "R3", data: [[0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0]] }
            };
        }
        return this._refPoints;
    }
    get reference() {
        var _a, _b;
        return {
            frame: this._reference.frame,
            origin: ((_b = (_a = Project.current()) === null || _a === void 0 ? void 0 : _a.findMachineById(this._reference.machineId)) === null || _b === void 0 ? void 0 : _b.pr) ||
                new PositionRotation(),
        };
    }
    get isTcpOrigin() {
        var _a;
        let robots = (_a = Project.current()) === null || _a === void 0 ? void 0 : _a.findMachineByType(ENTITY_TYPE.ROBOT);
        return !!robots.find((robot) => robot.tcp0.id === this.id);
    }
    get originMachine() {
        return Project.current().findMachineById(this._reference.machineId);
    }
    resetRefPointsData() {
        var _a, _b, _c;
        this._refPoints = {
            R1: { name: (_a = this.refPoints) === null || _a === void 0 ? void 0 : _a.R1.name, data: [[0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0]] },
            R2: { name: (_b = this.refPoints) === null || _b === void 0 ? void 0 : _b.R2.name, data: [[0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0]] },
            R3: { name: (_c = this.refPoints) === null || _c === void 0 ? void 0 : _c.R3.name, data: [[0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0]] }
        };
    }
    setReference(frame, machineId) {
        this._reference.frame = frame;
        this._reference.machineId = machineId || this._reference.machineId;
    }
    constructor(args = {}, type = ENTITY_TYPE.UCS, reference) {
        super(args);
        this.type = ENTITY_TYPE.UCS;
        this._reference = { frame: "global", machineId: "" };
        this.status = null;
        this.type = type;
        this._reference = reference || this._reference;
    }
    toJson() {
        let superData = super.toJson();
        superData.type = this.type;
        superData.reference = this._reference;
        superData.status = this.status;
        superData.refPoints = this._refPoints;
        return superData;
    }
    static fromJson(json) {
        let ucs = new Ucs();
        ucs.id = json.id;
        ucs.type = json.type;
        ucs._reference = json.reference || { frame: "global", machineId: "" };
        ucs.status = json.status;
        ucs.name = json.name;
        ucs.pr.x = json.pr.x;
        ucs.pr.y = json.pr.y;
        ucs.pr.z = json.pr.z;
        ucs.pr.rx = json.pr.rx;
        ucs.pr.ry = json.pr.ry;
        ucs.pr.rz = json.pr.rz;
        ucs._refPoints = json.refPoints;
        return ucs;
    }
}
exports.Ucs = Ucs;
Ucs.TCP_ORIGIN_NAME = "工具Tcp原点";
exports.PathTypeName = {
    "jointPoint": "关节点",
    "joints": "关节路径",
    "route": "位姿路径",
    "point": "位姿点"
};
class UniqueArray extends Array {
    constructor(uniques) {
        1;
        super();
        this.uniques = [];
        this.uniques = uniques;
    }
    get length() {
        return super.length;
    }
    push(...items) {
        if (this.uniques.length) {
            let find = items.find((item) => {
                return super.find((v) => {
                    return this.uniques.every((key) => v[key] == item[key]);
                });
            });
            if (find) {
                throw new Error(`Duplicate item: ${find}`);
            }
        }
        return super.push(...items);
    }
    forEach(callbackfn, thisArg) {
        super.forEach(callbackfn);
    }
}
exports.IO_GROUP = { feeding: "取料头", blanking: "下料头" };
class RobotCode {
    constructor(json) {
        this.globalVars = (json === null || json === void 0 ? void 0 : json.globalVars) || [];
        this.ioList = new UniqueArray(["name", "type"]);
        ((json === null || json === void 0 ? void 0 : json.ioList) || []).forEach(item => this.ioList.push(item));
        this.programs = [];
        ((json === null || json === void 0 ? void 0 : json.programs) || []).forEach((e) => this.programs.push(RobotProgram.fromJson(e)));
        this.processGroups = [];
        if (json === null || json === void 0 ? void 0 : json.processGroups) {
            this.processGroups = json.processGroups;
            if (Project._curOpening) {
                const ids = new Set(this.processGroups.map(item => item.id));
                if (ids.size !== this.processGroups.length) {
                    this.processGroups.forEach(item => item.id = Project._curOpening.getNewId("processGroup"));
                }
            }
        }
        else {
            ["默认类型", "取料", "上料", "换料", "下料", "其他"].forEach(name => this.addNewProcessGroup(name));
        }
    }
    addNewProcessGroup(name) {
        try {
            let newGroup = { id: (Project._curOpening || Project.current()).getNewId("processGroup"), name };
            this.processGroups.push(newGroup);
            return newGroup;
        }
        catch (e) {
            debugger;
        }
    }
    delProcessGroup(id) {
        let index = this.processGroups.findIndex(item => item.id === id);
        if (index > 0) {
            this.processGroups.splice(index, 1);
        }
    }
    moveProcessGroup(formIndex, toIndex) {
        if (toIndex < 0 || toIndex >= this.processGroups.length) {
            console.log("Invalid index");
            return;
        }
        const elementToMove = this.processGroups.splice(formIndex, 1)[0];
        this.processGroups.splice(toIndex, 0, elementToMove);
    }
    toJson() {
        return {
            globalVars: this.globalVars,
            ioList: this.ioList,
            programs: [...this.programs.map((item) => item.toJson())],
            processGroups: [...this.processGroups]
        };
    }
    static fromJson(json) {
        let code = new RobotCode(json);
        return code;
    }
    getIOListsByType(type) {
        return this.ioList.filter((io) => io.type === type);
    }
    getIOById(id) {
        return this.ioList.find((io) => io.id === id) || null;
    }
    usingNames(type) {
        var _a;
        let names = this.ioList
            .filter((item) => item.type === type)
            .map((item) => item.name);
        let curRobot = Project.current().curProgram.robot;
        names = names.concat(IOCfg_json_1.default[curRobot.model.brand]
            ? Object.keys((_a = IOCfg_json_1.default[curRobot.model.brand]) === null || _a === void 0 ? void 0 : _a.ioInfos)
            : []);
        return names;
    }
    createIO(name, type, val = 0, remark = "", using, dict, usingType) {
        let project = Project.current();
        return {
            id: project.getNewId("io"),
            name,
            type,
            using,
            val,
            remark,
            dict,
            usingType
        };
    }
    addIO(name, type, val = 0, remark = "", using, dict, usingType) {
        let nameIndex = 1;
        do {
            if (type === IO_TYPE.GO) {
                name = IO_TYPE.GO + nameIndex;
            }
            else {
                name = "#" + nameIndex;
            }
            nameIndex++;
        } while (this.usingNames(type).find((e) => e == name));
        let io = this.createIO(name, type, val, remark, using, dict, usingType);
        this.ioList.push(io);
        return io;
    }
    getProgram(id) {
        return this.programs.find((p) => p.id === id);
    }
    delProgram(id) {
        let index = this.programs.findIndex((p) => p.id === id);
        return this.programs.splice(index, 1);
    }
    delIO(id) {
        let index = this.ioList.findIndex((p) => p.id === id);
        return this.ioList.splice(index, 1);
    }
    delGlobalVar(id) {
        let index = this.globalVars.findIndex((p) => p.id === id);
        return this.globalVars.splice(index, 1);
    }
    getGlobalVar(id) {
        return this.globalVars.find((v) => v.id === id);
    }
    addGlobalVar(Var) {
        if (!Var.type)
            return;
        let v = this.globalVars.find((v) => v.id === Var.id);
        if (v) {
            v.name = Var.name;
            v.isStatic = Var.isStatic;
            v.initVal = Var.initVal;
            v.type = Var.type;
        }
        else {
            this.globalVars.push(Var);
        }
    }
}
exports.RobotCode = RobotCode;
class RobotProgram {
    constructor() {
        this.id = "";
        this.name = "";
        this.params = [];
        this.localVars = [];
        this.actions = [];
        this.code = {};
    }
    get isMain() {
        return this.name == "主程序";
    }
    getLocalVar(id) {
        return this.localVars.find((v) => v.id === id);
    }
    addLocalVar(Var) {
        if (!Var.type)
            return;
        let v = this.localVars.find((v) => v.id === Var.id);
        if (v) {
            v.name = Var.name;
            v.isStatic = Var.isStatic;
            v.initVal = Var.initVal;
            v.type = Var.type;
            v.isTemp = Var.isTemp;
        }
        else {
            this.localVars.push(Var);
        }
    }
    delLocalVar(id) {
        let index = this.localVars.findIndex((p) => p.id === id);
        this.localVars.splice(index, 1);
    }
    clearTempVar() {
        let tmpIndexs = [];
        this.localVars.forEach((v) => {
            if (v.isTemp) {
                tmpIndexs.push(v.id);
            }
        });
        tmpIndexs.forEach((v) => {
            this.delLocalVar(v);
        });
    }
    customStringify(obj) {
        const cache = new Set();
        return JSON.stringify(obj, (key, value) => {
            if (typeof value === "object" && value !== null) {
                if (cache.has(value)) {
                    return;
                }
                cache.add(value);
            }
            return value;
        });
    }
    toJson() {
        return {
            id: this.id,
            name: this.name,
            localVars: this.localVars,
            code: this.code,
            actions: this.actions,
        };
    }
    translationCalcStr(calcStr) {
        let { params, cmds, tempVars } = (0, ast_1.astReduce)(calcStr);
        for (let name of tempVars) {
            if (this.localVars.find((v) => v.name == name))
                continue;
            this.addLocalVar(this.createVar(name, VAL_TYPE.DOUBLE, 0, 0, false, true));
        }
        return { cmds, params };
    }
    createVar(name, type, initVal, val, isStatic = false, isTemp = false) {
        let project = Project.current();
        return {
            id: `${this.id}_${project.getNewId("var")}`,
            name,
            isStatic,
            type,
            initVal,
            val,
            isTemp,
        };
    }
    static fromJson(json) {
        let program = new RobotProgram();
        program.id = json.id;
        program.name = json.name;
        (json.localVars || []).forEach((e) => program.localVars.push(e));
        program.code = json.code;
        program.actions = json.actions;
        return program;
    }
}
exports.RobotProgram = RobotProgram;
class Robot extends Machine {
    get tool() {
        return this._tool;
    }
    static get current() {
        let project = Project.current();
        return project.curProgram.robot;
    }
    constructor(code) {
        super();
        this.tcps = [
            new Ucs({ name: Ucs.TCP_ORIGIN_NAME }, ENTITY_TYPE.TCP, {
                frame: "tool",
                machineId: "",
            }),
        ];
        this.axisAngles = [];
        this.type = ENTITY_TYPE.ROBOT;
        this.paths = [];
        this.isLockedTcp = false;
        this.customConfig = {
            host: "192.168.1.200",
            port: 8055,
            username: "root",
            password: "elite2014",
        };
        this._tool = null;
        this.code = code || new RobotCode();
    }
    delProcessGroup(id) {
        let paths = this.paths.filter(path => path.group === id);
        paths.forEach(path => path.group = this.code.processGroups[0].id);
        this.code.delProcessGroup(id);
    }
    findIO(filter) {
        return this.code.ioList.find((value, index) => filter(value, index));
    }
    findPath(filter) {
        return this.paths.find((value, index) => filter(value, index));
    }
    filterIO(filter) {
        return this.code.ioList.filter((value, index) => filter(value, index));
    }
    addTcp(tcp, name) {
        if (!tcp) {
            tcp = Project.current().createTcp({ status: "custom" }, false);
        }
        let index = 0;
        do {
            tcp.name = `${name ? name : DEVICE_TYPE_NAME.Tcp}${++index}`;
        } while (this.tcps.find((e) => e.name === tcp.name));
        let ucs = tcp;
        this.tcps.push(ucs);
        return ucs;
    }
    delTcp(id) {
        this.tcps.splice(this.tcps.findIndex((e) => e.id == id), 1);
    }
    delPath(id) {
        let index = this.paths.findIndex((e) => e.id == id);
        let path = this.paths.splice(index, 1);
        if (path[0].ioId) {
            this.code.delIO(path[0].ioId);
        }
        let store = (0, work_1.useWork)();
        store.notifyRemovePath(id);
    }
    addPath(name, points, type = "path", ioId = null, autoName = false, idNameSpace, group) {
        if (autoName) {
            let index = 0;
            let pathName = name == null || name == "" ? "路径" : name;
            let tempName = pathName + 1;
            while (this.paths.find((path) => path.name === tempName)) {
                index++;
                tempName = pathName + index;
            }
            name = tempName;
        }
        let path = this.createPath(name, points, type, ioId, idNameSpace || type, group);
        this.paths.push(path);
        return path;
    }
    createPath(name, points, type = "path", ioId = null, idNameSpace = type, group) {
        let project = Project.current();
        let path = {
            id: `${this.id}_${project.getNewId(idNameSpace)}`,
            name,
            type,
            points,
        };
        if (ioId != null) {
            path.ioId = ioId;
        }
        if (group != null) {
            path.group = group;
        }
        if (type !== 'path') {
            path.isTeach = true;
        }
        return path;
    }
    movePathElement(pathId, toIndex) {
        if (toIndex < 0 || toIndex >= this.paths.length) {
            console.log("Invalid index");
            return;
        }
        let fromIndex = this.paths.findIndex(item => item.id === pathId);
        const elementToMove = this.paths.splice(fromIndex, 1)[0];
        this.paths.splice(toIndex, 0, elementToMove);
    }
    setTool(tool) {
        if (Project.current() == null) {
            return null;
        }
        let store = (0, work_1.useWork)();
        if (this.tool) {
            store.notifyRemoveMachine(this.tool.id);
        }
        let clearTcps = this.tcps.filter((e) => e.status === "ref" || e.status === "custom" || e.isTcpOrigin || e.reference.frame === 'rp');
        this.tcps.length = 0;
        clearTcps.forEach((e) => this.tcps.push(e));
        this._tool = tool;
        if (tool == null) {
            return null;
        }
        const setMachinePr = (machine, e) => {
            machine.pr.x = e[0];
            machine.pr.y = e[1];
            machine.pr.z = e[2];
            machine.pr.rx = e[3];
            machine.pr.ry = e[4];
            machine.pr.rz = e[5];
        };
        tool.model.TCP.forEach((e, i) => {
            if (i === 0) {
                setMachinePr(tool, e);
            }
            else {
                let tcp = Project.current().createTcp({}, false);
                setMachinePr(tcp, e);
                this.tcps.push(tcp);
            }
        });
        let work = (0, work_1.useWork)();
        work.notifyAddMachine(tool, this.id);
    }
    createProgram(name) {
        let project = Project.current();
        let pg = new RobotProgram();
        pg.id = `${this.id}_${(project === null || project === void 0 ? void 0 : project.getNewId("program")) || "pgDefault" + this.id}`;
        pg.name = name;
        return pg;
    }
    createVar(name, type, initVal, val, isStatic = false, isTemp = false) {
        return Project.current().curProgram.program.createVar(name, type, initVal, val, isStatic, isTemp);
    }
    createIO(name, type, val = 0, remark = "", using, dict) {
        return this.code.createIO(name, type, val, remark, using, dict);
    }
    get tcp0() {
        return this.tcps[0];
    }
    get allVarList() {
        let project = Project.current();
        let program = project.curProgram;
        if (program) {
            let vars = [].concat(this.code.globalVars);
            return vars;
        }
        else {
            return this.code.globalVars;
        }
    }
    getAxisAngle(index) {
        let angle = this.axisAngles[index].zAngle;
        let zero = this.model.zero_angle[index];
        let offset = this.model.offset_angle[index];
        return angle + offset - zero;
    }
    static fromJson(json) {
        var _a;
        let robot = new Robot(RobotCode.fromJson(json.code));
        robot.id = json.id;
        robot.name = json.name;
        robot.type = json.type;
        robot.pr.x = json.pr.x || 0;
        robot.pr.y = json.pr.y || 0;
        robot.pr.z = json.pr.z || 0;
        robot.pr.rx = json.pr.rx || 0;
        robot.pr.ry = json.pr.ry || 0;
        robot.pr.rz = json.pr.rz || 0;
        robot.axisAngles.length = 0;
        (json.axisAngles || []).forEach((e) => robot.axisAngles.push(Axis.fromJson(e)));
        robot.tcps.shift();
        (json.tcps || []).forEach((e, index) => {
            if (index === 0) {
                let ucs = Ucs.fromJson(e);
                ucs.setReference("tool", "");
                robot.tcps.push(ucs);
            }
            else {
                robot.tcps.push(Ucs.fromJson(e));
            }
        });
        if (json.programs) {
            json["code"] = Object.assign(Object.assign({}, json.programs), { globalVars: json.programs.globalVar, programs: json.programs.codes });
            delete json.programs;
        }
        if (json.code.programs) {
            json.code.programs.forEach((program) => {
                if (program.varList)
                    program.localVars = program.varList;
                delete program.varList;
            });
        }
        robot.modelName = ((_a = json.model) === null || _a === void 0 ? void 0 : _a.name) || json.modelName;
        robot.paths = json.paths;
        robot.paths.forEach(item => {
            if (item.isTeach === undefined) {
                item.isTeach = true;
            }
            if (item.group) {
                if (!robot.code.processGroups.find(group => group.id === item.group)) {
                    let group = robot.code.processGroups.find(group => group.name === item.group);
                    if (group) {
                        item.group = group.id;
                    }
                    else {
                        item.group = robot.code.processGroups[0].id;
                    }
                }
            }
        });
        robot._tool = Machine.fromJson(json.tool);
        if (json.customConfig) {
            robot.customConfig = json.customConfig;
        }
        if (robot.code.programs.length == 0) {
            robot.code.programs.push(robot.createProgram("主程序"));
        }
        return robot;
    }
    toJson() {
        var _a;
        let superData = super.toJson();
        superData.tcps = this.tcps.map((e) => e.toJson());
        superData.axisAngles = this.axisAngles.map((e) => e.toJson());
        superData.paths = this.paths;
        superData.tool = (_a = this.tool) === null || _a === void 0 ? void 0 : _a.toJson();
        superData.code = this.code.toJson();
        superData.customConfig = this.customConfig;
        return superData;
    }
    setModel(model) {
        var _a;
        super.setModel(model);
        this.tcp0.id = `${this.id}_${this.tcp0.name}`;
        if (model && model.z_axes && this.axisAngles.length === 0) {
            for (let i = 1; i < model.z_axes.length; i++) {
                this.axisAngles.push(new Axis({
                    index: i,
                    val: ((_a = model === null || model === void 0 ? void 0 : model.zero_angle) === null || _a === void 0 ? void 0 : _a[i - 1]) || 0,
                    isLocked: false,
                    rotateMode: model.rotateModes[i],
                }));
            }
        }
    }
}
exports.Robot = Robot;
class ProgramsData {
    constructor() {
        this.project_id = "";
        this.vars = new Map();
        this.functions = [];
    }
    static fromProject(project) {
        let robot = project.curProgram.robot;
        let pg = ProgramsData.create(project === null || project === void 0 ? void 0 : project.id.toString(), {
            name: robot.name,
            brand: robot.model.brand,
        });
        pg.makeCode(project);
        return pg;
    }
    static create(project_id, robot_info) {
        if (!robot_info)
            throw new Error("创建程序需要传入robot参数");
        let pg = new ProgramsData();
        pg.project_id = project_id;
        pg.robot = { name: robot_info.name, brand: robot_info.brand };
        return pg;
    }
    toJson() {
        let json = {
            project_id: this.project_id,
            robot: this.robot,
            vars: this.vars,
            functions: this.functions,
        };
        return json;
    }
    makeCode(project) {
        const checkAction = (actions) => {
            actions.forEach((action) => {
                if ([1, 3.3].includes(action[0]) &&
                    (action[1] || []).includes("NONE")) {
                    throw new Error("指令参数非法！");
                }
            });
        };
        let robot = project.curProgram.robot;
        this.makeIO(robot.code.ioList);
        this.makePaths(robot.paths);
        this.makeRoutes(robot.paths, robot.code.ioList);
        this.makeVars(robot.code.globalVars);
        this.makeUcs(robot.tcps);
        this.makeUcs(project.getUcs(true));
        robot.code.programs.forEach((program) => {
            checkAction(program.actions);
            this.makeFuncVars(program.id, program.name, program.localVars);
            this.makeFuncActions(program.id, program.name, program.actions);
        });
    }
    makeIO(ioList) {
        ioList.forEach((io) => {
            this.vars[utils_1.Utils.pinyin(io.id)] = [
                "io",
                [io.type, io.name, io.using, io.remark],
            ];
        });
    }
    makePaths(paths) {
        paths
            .filter((path) => !path.ioId)
            .forEach((path) => {
            let points = path.points.map((point) => {
                if (["joints", "jointPoint"].includes(path.type)) {
                    let [r1, r2, r3, r4, r5, r6, r7, r8] = point;
                    return [
                        r1 || 0,
                        r2 || 0,
                        r3 || 0,
                        r4 || 0,
                        r5 || 0,
                        r6 || 0,
                        r7 || 0,
                        r8 || 0,
                    ];
                }
                else {
                    let [x, y, z, rx, ry, rz] = point;
                    return [x || 0, y || 0, z || 0, rx || 0, ry || 0, rz || 0];
                }
            });
            this.vars[utils_1.Utils.pinyin(path.id)] = [
                ["joints", "jointPoint"].includes(path.type) ? "joints" : "path",
                points,
                path.name,
            ];
        });
    }
    makeRoutes(paths, ioList) {
        paths
            .filter((path) => !!path.ioId)
            .forEach((path) => {
            let points = path.points.map((point) => {
                let [x, y, z, rx, ry, rz] = point;
                return [x || 0, y || 0, z || 0, rx || 0, ry || 0, rz || 0];
            });
            this.vars[utils_1.Utils.pinyin(path.id)] = [
                "route",
                [ioList.find((io) => io.id === path.ioId).name, points],
                path.name,
            ];
        });
    }
    makeVars(vars) {
        vars
            .filter((Var) => Var.type !== VAL_TYPE.LABEL)
            .forEach((Var) => {
            let initVal = this.defaultValue(Var);
            this.vars[utils_1.Utils.pinyin(Var.name)] = [Var.type, initVal, Var.name];
        });
    }
    makeUcs(ucses) {
        ucses.forEach((ucs) => {
            if (ucs.reference.frame === "rp") {
                this.vars[utils_1.Utils.pinyin(ucs.id)] = [
                    "ucs",
                    ["mframe",
                        [ucs.refPoints.R1.data[0]],
                        [ucs.refPoints.R2.data[0]],
                        [ucs.refPoints.R3.data[0]],
                        [ucs.refPoints.R1.data[1]],
                        [ucs.refPoints.R2.data[1]],
                        [ucs.refPoints.R3.data[1]],
                    ],
                    [ucs.name, ucs.refPoints.R1.name, ucs.refPoints.R2.name, ucs.refPoints.R3.name]
                ];
            }
            else {
                let frame = ucs.type === ENTITY_TYPE.TCP ? "tool" : "base";
                this.vars[utils_1.Utils.pinyin(ucs.id)] = [
                    "ucs",
                    [frame, ucs.pr.x, ucs.pr.y, ucs.pr.z, ucs.pr.rx, ucs.pr.ry, ucs.pr.rz],
                    ucs.name
                ];
            }
        });
    }
    makeFunc(func_id, func_name) {
        let program_name = func_name == "主程序" ? "main" : utils_1.Utils.pinyin(func_name);
        let func = this.functions.find((func) => func.name === program_name);
        if (!func) {
            func = {
                id: func_id,
                name: program_name,
                vars: new Map(),
                actions: new Array(),
            };
            this.functions.push(func);
        }
        return func;
    }
    makeFuncVars(func_id, func_name, vars) {
        let func = this.makeFunc(func_id, func_name);
        vars.forEach((Var) => {
            let initVal = this.defaultValue(Var);
            func.vars[Var.name] = [Var.type, initVal, ""];
        });
    }
    makeFuncActions(func_id, func_name, actions = []) {
        let program_name = func_name == "主程序" ? "main" : utils_1.Utils.pinyin(func_name);
        let func = this.makeFunc(func_id, program_name);
        func.actions = actions;
    }
    defaultValue(Var) {
        let initVal = Var.initVal;
        if (Var.type === VAL_TYPE.POSE) {
            if (initVal instanceof Array) {
                initVal.length = 6;
                for (let i in initVal) {
                    initVal[i] = initVal[i] || 0;
                }
            }
            else {
                initVal = [0, 0, 0, 0, 0, 0];
            }
        }
        else if (Var.type === VAL_TYPE.JOINT) {
            if (initVal == null) {
                initVal = Project.current().curProgram.robot.model.z_axes.map((a) => 0);
                initVal.length = Math.max(0, initVal.length - 1);
            }
        }
        return initVal;
    }
}
exports.ProgramsData = ProgramsData;
exports.OPERATORS = {
    AND: "&&",
    OR: "||",
    NOT: "!",
    XOR: "Xor",
    EQ: "==",
    NEQ: "!=",
    LT: "<",
    LTE: "<=",
    GT: ">",
    GTE: ">=",
};
